import AppConfig from '../appConfig';
import AbstractFetch from './AbstractFetch';

class SavedSearchesFetch extends AbstractFetch {
  static getAll() {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/searches/all/5', {
      method: 'GET',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    }).then((response) => {
      return response.json();
    });
  }

  static delete(id) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/searches/' + id, {
      method: 'DELETE',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    });
  }

  static save(data) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/searches/save', {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      return response.json();
    });
  }

  static update(id, data) {
    return AbstractFetch.fetch(AppConfig.apiUrl + '/v1/searches/' + id, {
      method: 'PUT',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      return response.json();
    });
  }
}

export default SavedSearchesFetch;
